import { useEffect, useState } from "react";

/** MUI */
import { makeStyles } from "@mui/styles";

/** Helpers */
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        border: "none", // "1px solid #cbd5e0",
        width: "100%",
        position: "relative",
    },
    container__left: {
        width: "75%",
        overflow: "auto",
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-start",
    },
    resizer: {
        backgroundColor: "#744FAC",
        cursor: "ew-resize",
        width: 1,
        minWidth: 1,
        position: "relative",
        zIndex: 3,
        "&:after": {
            content: '" "',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 21,
            height: 48,
            borderRadius: 20,
            background: `#744FAC url('data:image/svg+xml,%3Csvg xmlns="http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" width="24" height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"%3E%3Cpath fill="white" d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2z"%2F%3E%3C%2Fsvg%3E') center center no-repeat`,
        },
    },
    resizerHidden: {
        visibility: "hidden",
    },
    resizerNoBtn: {
        "&:after": {
            display: "none",
        },
    },
    container__right: {
        width: "25%",
        overflow: "auto",
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-start",
    },
    leftChildHolder: {
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-start",
        overflow: "hidden",
    },
    rightChildHolder: {
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-end",
        overflow: "hidden",
    },
}));

const SplitView = (props) => {
    const { left: LEFT_PART, right: RIGHT_PART, widths, showSplit, isInDialog } = props;
    const classes = useStyles();

    /** States */
    const [WIDTHS, setWIDTHS] = useState(widths);

    /** Effects */
    /** - widths */
    useEffect(() => setWIDTHS(widths), [widths]);

    /** - resizer */
    useEffect(() => {
        // Query the element
        const resizer = document.getElementById(isInDialog ? "iidDragMe" : "dragMe");
        const leftSide = resizer.previousElementSibling;
        const rightSide = resizer.nextElementSibling;

        // The current position of mouse
        let x = 0;
        let y = 0;
        let leftWidth = 0;

        // Handle the mousedown event
        // that's triggered when user drags the resizer
        const mouseDownHandler = function (e) {
            // Get the current mouse position
            x = e.clientX;
            y = e.clientY;
            leftWidth = leftSide.getBoundingClientRect().width;

            // Attach the listeners to `document`
            document.addEventListener("mousemove", mouseMoveHandler);
            document.addEventListener("mouseup", mouseUpHandler);
        };

        const mouseMoveHandler = function (e) {
            // How far the mouse has been moved
            const dx = e.clientX - x;
            const dy = e.clientY - y;

            const newLeftWidth = ((leftWidth + dx) * 100) / resizer.parentNode.getBoundingClientRect().width;
            leftSide.style.width = `calc(${newLeftWidth}% + 0px)`;
            rightSide.style.width = `calc(${100 - newLeftWidth}% - 0px)`;

            resizer.style.cursor = "col-resize";
            document.body.style.cursor = "col-resize";

            leftSide.style.userSelect = "none";
            leftSide.style.pointerEvents = "none";

            rightSide.style.userSelect = "none";
            rightSide.style.pointerEvents = "none";
        };

        const mouseUpHandler = function () {
            resizer.style.removeProperty("cursor");
            document.body.style.removeProperty("cursor");

            leftSide.style.removeProperty("user-select");
            leftSide.style.removeProperty("pointer-events");

            rightSide.style.removeProperty("user-select");
            rightSide.style.removeProperty("pointer-events");

            document.selection?.empty();
            window.getSelection()?.removeAllRanges();

            // Remove the handlers of `mousemove` and `mouseup`
            document.removeEventListener("mousemove", mouseMoveHandler);
            document.removeEventListener("mouseup", mouseUpHandler);
        };

        // Attach the handler
        resizer.addEventListener("mousedown", mouseDownHandler);
    }, []);

    return (
        <div className={classes.container} id="split_container">
            <div
                className={classes.container__left}
                style={{
                    maxWidth: WIDTHS?.left?.max || undefined,
                    minWidth: WIDTHS?.left?.min || undefined,
                }}
                id={"left"}
            >
                <div
                    className={classes.leftChildWrapper}
                    style={{ width: WIDTHS?.left?.max ? WIDTHS?.left?.max - 4 : WIDTHS?.left?.max }}
                >
                    <div className={classes.leftChildHolder}>{LEFT_PART}</div>
                </div>
            </div>
            <div
                className={clsx(
                    classes.resizer,
                    // RIGHT_PART?.props?.headData?.cols?.length || classes.resizerHidden,
                    WIDTHS?.right?.max === WIDTHS?.right?.min && classes.resizerNoBtn
                )}
                id={isInDialog ? "iidDragMe" : "dragMe"}
            ></div>
            <div
                className={classes.container__right}
                style={{
                    maxWidth: WIDTHS?.right?.max || undefined,
                    minWidth: WIDTHS?.right?.min,
                }}
                id={"right"}
            >
                <div
                    className={classes.rightChildWrapper}
                    style={{ width: WIDTHS?.right?.max ? WIDTHS?.right?.max - 4 : WIDTHS?.right?.max }}
                >
                    <div className={classes.rightChildHolder}>{RIGHT_PART}</div>
                </div>
            </div>
        </div>
    );
};

export default SplitView;
